export default __webpack_public_path__ + "static/media/cirrusPic.41a1d79e.png";